//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // XButton,// XInput,
import 'vux'
import { mapState } from 'vuex'

import { service, nativeApi } from '@/common/index'
import { fetch } from '@/page/index'
import UserHeader from "./UserHeader";

export default {
  components: {
    UserHeader
  },
   data () {
     return {
       list: [],

      /** 刷新用变量 */
       pageIndex: 1,
       pageRows: 10,
       refreshing: false,
       finished: false,
       loading: false
     }
   },
   computed: {
     ...mapState({
       userInfo: (state) => state.user.userInfo,
       languageCode: (state) => state.user.languageCode
     })
   },
   created () {},
   activated: function () {},
   methods: {
     onRefresh () {
      //  console.log('refresh')
     // 状态设置
       this.finished = false
      //  this.refreshing = true
       this.loading = true
     // 页数设置
       this.pageIndex = 1
       this.list = []
       this.onLoad()
     },
     onLoad () {
      //  console.log('load')
       this.requestList()
     },
     requestList () {
      //  console.log('requestList')
       fetch.srmBaseNotificationRestful_listByPage({
          lan: this.languageCode,
          userId: this.userInfo.userId,
          pageIndex: this.pageIndex,
          pageRows: this.pageRows
        })
        .then((res) => {
         // 状态设置
          if (res.status === 'S') {
            if (res.code === 'S') {
              // 一、清楚最后多余的数据
              // const curPageIndex = res.page.curIndex            // 当前页数
              // const curIndex = (curPageIndex - 1) * this.pageRows   // index
              // const lastLength = this.list.length - curIndex  // 剩余长度
              // this.list.splice(curIndex, lastLength)
              // this.list = this.list.concat(res.data) // 拼接数据

              // 判断当前页与下一页是否相同，如果相同表示到达最后一页
              if (res.page.curIndex !== res.page.nextIndex) {
                // 不是最后一页就缓存下一页的页码
                this.pageIndex = res.page.nextIndex   // 更新页数
                // 将数据拼接
                // this.list = [...this.list, ...res.data]
                this.setListData(res.data)
                // console.log('不是最后一页',this.list.length);
              } else {
                // 数据length不足row，没有更多数据，不继续往后加载
                // this.finished = true
                // console.log('是最后一页');
                // 判断当前数据总数与后台数据总数是否相同来判断是否已添加上最后一页数据
                if (this.list.length >= res.page.count) {
                  // console.log('已添加最后一页数据，没有更多了');
                  this.finished = true
                }else{
                  // this.list = [...this.list, ...res.data]
                  this.setListData(res.data)
                  // console.log('添加最后一页数据',this.list);
                }
              }

            }
          }
          setTimeout(() => {
            this.refreshing = false
            this.loading = false
          }, 2000);
        })
     },
     setListData(data) {
       this.list = [...this.list, ...data]
       this.list.forEach((v,i)=>{
         if (v.notificationContent !== null) {
            if (v.notificationContent.indexOf('<') !== -1) {
              // console.log(v,v.notificationContent.indexOf('>'),'v')
              // console.log(v,v.notificationContent.lastIndexOf('<'),'v2')
              // console.log(v.notificationContent.slice(v.notificationContent.indexOf('>') + 1,v.notificationContent.lastIndexOf('<')))
              v.notificationContent = v.notificationContent.slice(v.notificationContent.indexOf('>') + 1,v.notificationContent.lastIndexOf('<'))
            }
         }

       })
     }
   },
   watch: {},
   mounted () {
     this.requestList()
   }
}



// WEBPACK FOOTER //
// ./src/page/srm/home/Message.vue